import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// ✅ OTIMIZAÇÃO: Silenciar logs em produção para melhorar performance
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.error = () => {};
  console.warn = () => {};
}

// Criando o ponto de entrada para a aplicação React
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App /> {/* Carregando o componente principal da aplicação */}
  </React.StrictMode>
);

// ✅ PWA: registra o Service Worker só em produção (em dev atrapalharia o HMR).
// Estratégia conservadora (network-first p/ HTML) — não serve versão velha do app.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
